import { Contact } from 'models/Contact';
import { ASCENDING_DESCENDING_COPY, SORTING_ORDER } from 'models/Sort';

export type EnterpriseContactsPeopleTable = Pick<
  Contact,
  'email' | 'phone' | 'preApproved' | 'existUser' | 'firstName' | 'companyName'
> &
  Record<'edit' | 'checkbox', string>;

export const TABLE_COLUMNS: Array<keyof EnterpriseContactsPeopleTable> = [
  'checkbox',
  'firstName',
  'email',
  'phone',
  'companyName',
  'preApproved',
  'existUser',
  'edit',
];

export const HEADING_TRANSLATIONS: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  firstName: 'name',
  email: 'email',
  phone: 'phone',
  preApproved: 'preApproved',
  existUser: 'resolveAccount',
  companyName: 'company',
};

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  firstName: 'sortName',
  email: 'email',
  phone: 'phone',
  companyName: 'companyName',
  preApproved: 'preApproved',
  existUser: 'existUser',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  checkbox: 20,
  preApproved: 120,
  existUser: 120,
  edit: 70,
};

export const REQUIRED_COLUMNS: Array<keyof EnterpriseContactsPeopleTable> = [
  'checkbox',
];

export const MULTI_SORT_DIRECTION_COPY = {
  [SORTING_VALUES.phone]: ASCENDING_DESCENDING_COPY,
  [SORTING_VALUES.preApproved]: {
    [SORTING_ORDER.A_TO_Z]: 'preApprovedLast',
    [SORTING_ORDER.Z_TO_A]: 'preApprovedFirst',
  },
  [SORTING_VALUES.existUser]: {
    [SORTING_ORDER.A_TO_Z]: 'existUserLast',
    [SORTING_ORDER.Z_TO_A]: 'existUserFirst',
  },
};

export const LOCKED_COLUMN: keyof EnterpriseContactsPeopleTable = 'firstName';
